/**
 * true wyłącznie wewnątrz snapshotu Playwrighta (scripts/src/prerender/snapshot.ts
 * wstrzykuje tę flagę przez page.addInitScript, przed jakąkolwiek nawigacją) —
 * nigdy w realnej sesji użytkownika. Pozwala komponentom (patrz DeferredSection)
 * pomijać viewport-gating i montować się od razu, żeby snapshot HTML zawierał
 * pełną treść potrzebną do SEO, mimo że Playwright nie przewija strony.
 */
export const isPrerenderMode =
  typeof window !== 'undefined' &&
  (window as unknown as { __PRERENDER_MODE__?: boolean }).__PRERENDER_MODE__ === true;
